import { Stack, Typography } from "@mui/material";

import HomePageCard from "../HomePageCard";

export const EmptyCard = ({ title }: { title: string }) => (
  <HomePageCard title={title}>
    <Stack direction="row" alignItems="center" sx={{ p: 3, height: 161 }}>
      <Typography
        variant="caption"
        color="text.primary"
        sx={{ textTransform: "lowercase", "&:first-letter": { textTransform: "capitalize" } }}
      >
        No {title} yet
      </Typography>
    </Stack>
  </HomePageCard>
);
